<template>
	<div class="textfield ml-3 position-relative">
		<label class="d-flex"
			>{{ text }} <span v-show="isMandatory" class="asterik">*</span></label
		>
		<div class="w-100 position-relative">
			<b-skeleton v-if="showLoader" height="38px"></b-skeleton>
			<template v-else>
				<b-form-input
					:placeholder="placeholder"
					v-model="modelValue[modelKey]"
					:disabled="disabled"
					@keyup.enter="$emit('enter')"
					:class="{
						error: error,
						'pd-right': type === 'password',
						'pd-green-tick': modelKey == 'newPswd',
					}"
					@input="$emit('input')"
					:type="type"
					autocomplete="new-password"
				></b-form-input>
				<template v-if="modelKey === '$model'">
					<span
						v-if="!modelValue.required && modelValue.$dirty"
						class="required-font top-38px"
						>Required</span
					>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "TextField",
	props: {
		showLoader: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: "text",
		},
		text: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Enter",
		},
		modelValue: {
			type: Object,
			required: true,
		},
		modelKey: {
			type: String,
			required: true,
		},
		isMandatory: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style>
.top-38px {
	top: 38px;
}
.pd-right {
	padding-right: 20px !important;
}
.pd-green-tick {
	padding-right: 40px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

input[type="number"] {
	-moz-appearance: textfield;
}
.textfield .form-control:focus{
    box-shadow:unset !important;
    border: 1px solid #D0D5DD !important;
}
.textfield .form-control{
border-radius:8px;
}
.textfield .form-control::placeholder {
    font-family: Montserrat;
    font-weight: 400;
    font-size: 14px;
    color: #667085;
}
</style>
